import type { Resource } from '../../';
export const country_countries_AD: Resource = {"default":"Andorra"};
